<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ 'mymail.app.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <h2 class="rs-tit3">
              {{ 'mymail.manage.your.mailboxes.title' | translate }}
            </h2>
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-columns small-12 medium-8">
                <div class="rs-flex-row rs-flex-dir-col-small-only rs-flex-middle">
                  <div class="rs-flex-column">
                    <div class="rs-form-item">
                      <mprd-mailboxes-list
                        [mailboxes]="mailboxes$ | async"
                        [selectedMailbox]="selectedMailbox$ | async"
                        (selectMailbox)="onSelectMailbox($event)"
                      >
                      </mprd-mailboxes-list>
                    </div>
                  </div>
                  <mprd-read-mymail-container
                    [selectedMail]="selectedMailbox$ | async"
                  ></mprd-read-mymail-container>
                </div>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <div class="text-center medium-text-right">
                  <p>
                    <mprd-create-mailbox-button
                      *ngIf="showCreateMailboxLink$ | async"
                      (click)="createMailBox()"
                    ></mprd-create-mailbox-button>
                  </p>
                </div>
              </div>
            </div>
            <mprd-manage-mailbox-container></mprd-manage-mailbox-container>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
